/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createSubscriber,
	createHook,
	type HookReturnValue,
	type BoundActions,
	type HookFunction,
	type SubscriberComponent,
} from '@atlassian/react-sweet-state';
import type { State } from '../model/types.tsx';
import Store from '../store.tsx';
import type { Actions } from '../types.tsx';

export const useHelpPanel: HookFunction<
	State,
	BoundActions<State, typeof import('../actions/index.tsx')>,
	void
> = createHook(Store);

export const useHelpPanelActions: HookFunction<
	State,
	BoundActions<State, typeof import('../actions/index.tsx')>,
	void
> = createHook(Store, {
	selector: null,
});

export type UseHelpPanelType = () => HookReturnValue<State, Actions>;

export const HelpPanelSubscriber: SubscriberComponent<
	State,
	BoundActions<State, typeof import('../actions/index.tsx')>,
	unknown
> = createSubscriber<State, Actions>(Store, {
	displayName: 'HelpPanelSubscriber',
});

export const HelpPanelActionsSubscriber: SubscriberComponent<
	null,
	BoundActions<State, typeof import('../actions/index.tsx')>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any>
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
> = createSubscriber<State, Actions, null, Record<any, any>>(Store, {
	displayName: 'HelpPanelActionsSubscriber',
	selector: null,
});
